var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 13,
    viewBox: "0 0 25 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60411 12.2049C2.0748 12.7056 1.2556 12.689 0.774383 12.1679C0.293164 11.6468 0.33215 10.8186 0.861461 10.318L11.1458 0.591086C11.1872 0.5247 11.2352 0.461361 11.29 0.402007C11.5465 0.124315 11.8989 -0.0100985 12.2523 0.000688553C12.6057 -0.0100985 12.9582 0.124315 13.2146 0.402007C13.2694 0.461361 13.3175 0.5247 13.3588 0.591086L23.6432 10.318C24.1725 10.8186 24.2115 11.6468 23.7303 12.1679C23.249 12.689 22.4298 12.7056 21.9005 12.2049L12.2523 3.07972L2.60411 12.2049Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion1);
export default __webpack_public_path__ + "static/media/Union (1).98c9c46d069a9c3a7c44f373e2ad43ea.svg";
export { ForwardRef as ReactComponent };